document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('.adaptation_roi__calcMethod__inner__container__block__header');

  headers.forEach((header) => {
    header.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const icon = this.querySelector('.adaptation_roi__calcMethod__inner__container__block__header__icon');

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        icon.textContent = '+';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.textContent = '-';
      }
    });
  });
});
